import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import colorSharp from "../../assets/img/color-sharp-green.png";
import colorSharp2 from "../../assets/img/color-sharp2-green.png";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { FaEye } from "react-icons/fa";
import "../../css/Awards/Awards.css";
import DisplayImageSlider from "../DisplayImageSlider";

const Awards = () => {
  const [awards, setAwards] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  async function fetchAwards() {
    try {
      const projectRef = collection(db, "awards");
      const q = query(projectRef, orderBy("awardOrder", "asc")); 
      const querySnap = await getDocs(q);
  
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
  
      setAwards(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchAwards();
  }, []);

  const AwardHandleMouseEnter = (e) => {
    const image = e.currentTarget.querySelector("img");
    const icon = e.currentTarget.querySelector(".icon");
    const div = e.currentTarget;
    if (image) image.style.filter = "brightness(30%)";
    if (div) div.style.cursor = "pointer";
    if (icon) icon.style.opacity = "1";
  };

  const AwardHandleMouseLeave = (e) => {
    const image = e.currentTarget.querySelector("img");
    const icon = e.currentTarget.querySelector(".icon");
    if (image) image.style.filter = "brightness(100%)";
    if (icon) icon.style.opacity = "0";
  };

  const handleImageClick = (images) => {
    setSelectedImages(images); // Update to set all images
    setOpenFullScreenImage(true);
  };

  return (
    <>
      <section className="skill" id="awards">
        <div className="container" style={{ marginTop: "70px"}}>
          <div className="col-12" >
            <div className="skill-bx wow zoomIn">
              <div className="about-section">
                <h1 className="background-text">AWARDS</h1>
                <h1 className="foreground-text" style={{ color: "green",fontWeight:"800" }}>
                  AWARDS
                  <div className="underline" style={{ backgroundColor: "green" }}></div>
                </h1>
              </div>
              <div className="grid-container" >
                {awards.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      backgroundColor: "black",
                      padding: "20px",
                      paddingBottom: "10px",
                      position: "relative",
                      border: "3px solid green",
                      borderRadius: "40px",
                    }}
                    onMouseEnter={AwardHandleMouseEnter}
                    onMouseLeave={AwardHandleMouseLeave}
                    onClick={() => handleImageClick(item.data.awardCertificates)} // Pass all images
                  >
                    <div style={{ position: "relative", marginBottom: "10px" }} className="awardDiv">
                      <img
                        src={item.data.awardCertificates[0]} // Display the first image in grid
                        alt="Image"
                        style={{
                          display: "block",
                          width: "100%",
                          height: "200px",
                          borderRadius: "20px",
                          transition: "all 0.3s ease",
                          border: "2px solid white",
                        }}
                      />
                      <i
                        className="icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "white",
                          fontSize: "24px",
                          opacity: 0,
                          transition: "opacity 0.3s ease",
                        }}
                      >
                        <FaEye style={{ fontSize: "40px", color: "darkgreen" }} />
                      </i>
                      <p
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: "50%",
                          transform: "translateX(-50%)",
                          background: "black",
                          padding: "10px",
                          margin: 0,
                          color: "lightgreen",
                          fontWeight: "700",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          fontSize: "15px",
                          borderTop: "2px solid white",
                          borderLeft: "2px solid white",
                          borderRight: "2px solid white",
                        }}
                      >
                        {item.data.awardPosition}
                      </p>
                    </div>
                    <p
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontWeight: "800",
                      }}
                    >
                      {item.data.awardName}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {openFullScreenImage && (
          <DisplayImageSlider
            onClose={() => setOpenFullScreenImage(false)}
            images={selectedImages} // Pass all images to DisplayImageSlider
          />
        )}
        <img className="background-image-left" src={colorSharp} alt="Image" />
        <img className="background-image-right" src={colorSharp2} alt="Image" />
      </section>
    </>
  );
};

export default Awards;
